import React from "react";

const TopHeader = () => {
    return (
        <div className="bg-dark">
            <h3 className="text-white p-2 m-0 text-center">Food  App</h3>
         </div>
    );
};

export default TopHeader;
